"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageHSGTStock = void 0;
var react_1 = __importDefault(require("react"));
var crumbs_1 = require("../crumbs");
var react_router_dom_1 = require("react-router-dom");
var hotlinks_1 = require("../quotetable/hotlinks");
var quotetable_1 = require("../quotetable");
/**
 * 沪深港通stock
 * @returns
 */
function PageHSGTStock() {
    var location = (0, react_router_dom_1.useLocation)();
    var hash = location.hash;
    return (react_1.default.createElement("div", { className: "hsgtstock" },
        react_1.default.createElement(crumbs_1.CrumbsWithRefreshLine, null),
        (hash == '#hk_sh_stocks' || hash == '#hk_sz_stocks') &&
            react_1.default.createElement("div", { className: "hlmzb scf" },
                react_1.default.createElement("div", { className: "hl" },
                    react_1.default.createElement(hotlinks_1.HSGT_GGTHot, null))),
        react_1.default.createElement(quotetable_1.QuoteTable, null)));
}
exports.PageHSGTStock = PageHSGTStock;
